import { InputsForgot } from './forgot-password/forgot-password'
import LoginTemplate from './login'
import { LOGIN_SITE } from './login.enum'
import { LoginTemplateInterface } from './login.types'
import { InputsLogin } from './login-form/login-form'

export { LOGIN_SITE }
export type { InputsForgot, InputsLogin, LoginTemplateInterface }
export { LoginTemplate }
